

import React, { useState } from 'react';
import {
    Divider,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ListSubheader,
   
    List,
    Collapse,
} from '@mui/material';
import HomeIcon from "@mui/icons-material/Home";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import ReportIcon from '@mui/icons-material/Report';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore'; 
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';


const SideBar = ({ setSelectedPage, selectedPage }) => {
    const [openViewUsers, setOpenViewUsers] = useState(false);

    const handleViewUsersClick = () => {
        setOpenViewUsers(!openViewUsers);
    };

    return (
        <>
            <ListItemButton onClick={() => setSelectedPage('Home')}>
                <ListItemIcon>
                    <HomeIcon color={selectedPage === 'Home' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Home" />
            </ListItemButton>

            {/* Enroll Section */}
            <ListItemButton onClick={() => setSelectedPage('Students')}>
                <ListItemIcon>
                    <PersonOutlineIcon color={selectedPage === 'Students' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Enroll Students" />
            </ListItemButton>
            <ListItemButton onClick={() => setSelectedPage('Teachers')}>
                <ListItemIcon>
                    <SupervisorAccountOutlinedIcon color={selectedPage === 'Teachers' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Enroll Teachers" />
            </ListItemButton>
            <ListItemButton onClick={() => setSelectedPage('Staff')}>
                <ListItemIcon>
                    <SupervisorAccountOutlinedIcon color={selectedPage === 'Staff' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Enroll Staff" />
            </ListItemButton>
            <ListItemButton onClick={() => setSelectedPage('Subjects')}>
                <ListItemIcon>
                    <AssignmentIcon color={selectedPage === 'Subjects' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Add Subjects" />
            </ListItemButton>
          
            <ListItemButton onClick={() => setSelectedPage('FacultyLeave')}>
                <ListItemIcon>
                    <HolidayVillageIcon color={selectedPage === 'FacultyLeave' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Faculty On Leave" />
            </ListItemButton>

            <ListItemButton onClick={() => setSelectedPage('StaffLeave')}>
                <ListItemIcon>
                    <HolidayVillageIcon color={selectedPage === 'StaffLeave' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Staff On Leave" />
            </ListItemButton>

            {/* View Users Section */}
            <ListItemButton onClick={handleViewUsersClick}>
                <ListItemIcon>
                    <AccountCircleOutlinedIcon color={openViewUsers ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="View Users" />
                {openViewUsers ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openViewUsers} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton onClick={() => setSelectedPage('ViewStudents')}>
                        <ListItemIcon>
                            <PersonOutlineIcon color={selectedPage === 'ViewStudents' ? 'primary' : 'inherit'} />
                        </ListItemIcon>
                        <ListItemText primary="View Students" />
                    </ListItemButton>
                    <ListItemButton onClick={() => setSelectedPage('ViewTeachers')}>
                        <ListItemIcon>
                            <SupervisorAccountOutlinedIcon color={selectedPage === 'ViewTeachers' ? 'primary' : 'inherit'} />
                        </ListItemIcon>
                        <ListItemText primary="View Teachers" />
                    </ListItemButton>
                    <ListItemButton onClick={() => setSelectedPage('ViewStaff')}>
                        <ListItemIcon>
                            <SupervisorAccountOutlinedIcon color={selectedPage === 'ViewStaff' ? 'primary' : 'inherit'} />
                        </ListItemIcon>
                        <ListItemText primary="View Staff" />
                    </ListItemButton>
                </List>
            </Collapse>

            {/* Other Sidebar Items */}
           

            <ListItemButton onClick={() => setSelectedPage('Complains')}>
                <ListItemIcon>
                    <ReportIcon color={selectedPage === 'Complains' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Complains" />
            </ListItemButton>
            <Divider sx={{ my: 1 }} />
            <ListSubheader component="div" inset>
                User
            </ListSubheader>
            <ListItemButton onClick={() => setSelectedPage('RequestLeave')}>
                <ListItemIcon>
                    <HolidayVillageIcon color={selectedPage === 'RequestLeave' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Request Leave" />
            </ListItemButton>
            <ListItemButton onClick={() => setSelectedPage('AdminProfile')}>
                <ListItemIcon>
                    <AccountCircleOutlinedIcon color={selectedPage === 'AdminProfile' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Profile" />
            </ListItemButton>
            <ListItemButton onClick={() => setSelectedPage('Logout')}>
                <ListItemIcon>
                    <ExitToAppIcon color={selectedPage === 'Logout' ? 'primary' : 'inherit'} />
                </ListItemIcon>
                <ListItemText primary="Logout" />
            </ListItemButton>
        </>
    );
}

export default SideBar;



